import { useTranslation } from "react-i18next";

interface LastSyncInfoProps {
  lastSyncTime: Date | null;
}

export function LastSyncInfo({ lastSyncTime }: LastSyncInfoProps) {
  const { t } = useTranslation();

  if (!lastSyncTime) return null;

  return (
    <div className="text-xs text-muted-foreground">
      {t("offlineStatus.lastSync", {
        time: lastSyncTime.toLocaleTimeString(),
      })}
    </div>
  );
}
